import { render, staticRenderFns } from "./LoyaltyMembersSummary.vue?vue&type=template&id=bd92816c&"
import script from "./LoyaltyMembersSummary.vue?vue&type=script&lang=js&"
export * from "./LoyaltyMembersSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports